module.exports = __webpack_public_path__ + "static/media/fly0185.1d36a24d.webp";